( function() {
    
    // Initialize Swiper with desired settings
    const swiperOptions = {
        loop: false,
        grabCursor: true,
        slidesPerView: 1,
        spaceBetween: 20,
        breakpoints: {
            600: {
                slidesPerView: 2,
            },
            1000: {
                slidesPerView: 3,
            }
        },
        navigation: {
            nextEl: '.pif-carousel .swiper-button-next',
            prevEl: '.pif-carousel .swiper-button-prev',
        },
    };

    // Create Swiper instance
    const swiper = new Swiper('.pif-carousel .swiper-container', swiperOptions);

})();